/**
 * Formatting helpers.
 */

import { CURRENCY_SYMBOL_DEFAULT } from './constants.js';

/**
 * Format a sen amount as a display money string.
 * Internal unit is sen (1 RM = 100 sen). 10 → "RM 0.10", 15000 → "RM 150.00".
 */
export function formatMoney(sen: number, symbol = CURRENCY_SYMBOL_DEFAULT): string {
  const sign = sen < 0 ? '-' : '';
  const abs = Math.abs(Math.round(sen));
  const ringgit = Math.floor(abs / 100);
  const cents = abs % 100;
  return `${sign}${symbol} ${ringgit.toLocaleString()}.${cents.toString().padStart(2, '0')}`;
}

/** Convert integer sen to RM float for calculations / display with custom format. */
export function senToRm(sen: number): number {
  return sen / 100;
}

/** Convert user-facing RM (possibly decimal) to integer sen for storage. */
export function rmToSen(rm: number): number {
  return Math.round(rm * 100);
}

export function formatRelativeTime(ts: number, now: number = Date.now()): string {
  const diff = now - ts;
  if (diff < 60_000) return '刚刚';
  if (diff < 3600_000) return `${Math.floor(diff / 60_000)} 分钟前`;
  if (diff < 86400_000) return `${Math.floor(diff / 3600_000)} 小时前`;
  if (diff < 7 * 86400_000) return `${Math.floor(diff / 86400_000)} 天前`;
  return new Date(ts).toLocaleDateString('zh-CN');
}

export function formatDateYMD(ts: number): string {
  const d = new Date(ts);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Safely parse JSON, returning fallback on failure. */
export function parseJsonSafe<T>(s: string | null | undefined, fallback: T): T {
  if (s == null) return fallback;
  try { return JSON.parse(s) as T; } catch { return fallback; }
}
